import { contantAuthentication } from '@contants/index';
import { loadFromLocalStorageObjectFromBase64 } from '@databases/localStorage';
import axios from 'axios';
import { differenceInSeconds } from 'date-fns';
import { isEmpty } from 'lodash';
import moment from 'moment';

export const FORMAT_DATE_ISO = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match('rgba')) {
    let triplet = hex.slice(5).split(',').slice(0, -1).join(',');
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
  }
};

export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} giây`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} phút`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} giờ`;
  else if (difference < 86400 * 30) return `${Math.floor(difference / 86400)} ngày`;
  else if (difference < 86400 * 30 * 12) return `${Math.floor(difference / 86400 / 30)} tháng`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} năm`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substr(2, tempId.length - 1);
  return uid;
}

export function getQueryParam(prop) {
  var params = {};
  var search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf('?') + 1)
  );
  var definitions = search.split('&');
  definitions.forEach(function (val, key) {
    var parts = val.split('=', 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(' ');
}

export const flat = (array) => {
  var result = [];
  array.forEach(function (a) {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = result.concat(flat(a.children));
    }
  });
  return result;
};

export function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

let delayTimer;
export const doSearch = (callback) => {
  clearTimeout(delayTimer);
  delayTimer = setTimeout(function () {
    callback();
  }, 1000); // Will do the ajax stuff after 1000 ms, or 1 s
};

export const formatDateToString = (date, patten = 'DD-MM-YYYY HH:mm') =>
  date ? moment(date).format(patten).toString() : '';

export const convertLocaltimeToUTC = (date, hour) => {
  let result = null;
  try {
    if (date) {
      const localDateTimeMoment = moment(
        `${moment(new Date(date)).format('YYYY-MM-DD')} ${hour}`,
        'YYYY-MM-DD HH:mm:ss.SSS'
      );

      const utcDateTimeMoment = localDateTimeMoment.utc();

      result = utcDateTimeMoment.toISOString();
    }
  } catch (e) {
    console.log('Exception at convertLocaltimeToUTC');
    console.log(e);
  }

  return result;
};

export function isNullOrEmpty(value) {
  return value === undefined || value === null || value === '';
}

export function formatCurrency(money, digits) {
  if (isNullOrEmpty(money)) {
    return '0';
  }

  // Convert to number and handle negative sign
  let num = Number(money);
  let absNum = Math.abs(num); // Get absolute value for formatting
  let formatted = absNum.toLocaleString('vi-VN', {
    minimumFractionDigits: digits ? digits : 0,
    maximumFractionDigits: digits ? digits : 0
  });

  return num < 0 ? `-${formatted}` : formatted;
}

export const formatNumber = (text) => {
  // Remove non-numeric characters except the decimal point
  let cleanedText = text.replace(/[^0-9.]/g, '');

  // Prevent multiple decimal points
  const parts = cleanedText.split('.');
  if (parts.length > 2) {
    cleanedText = parts[0] + '.' + parts.slice(1).join('');
  }

  // Limit decimal places to 3
  if (cleanedText.includes('.')) {
    const [integer, decimal] = cleanedText.split('.');
    cleanedText = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimal.slice(0, 3);
  } else {
    cleanedText = cleanedText.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return cleanedText;
};

export const formatVNDCurrency = (value) => {
  if (!value) return '';
  const formattedValue = new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND'
  }).format(value);
  return formattedValue.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const communityList = [
  {
    label: 'Tất cả',
    value: 'ALL'
  },
  {
    label: 'Hải Phòng',
    value: 'HP'
  },
  {
    label: 'Hà Nội',
    value: 'HN'
  }
];

export const warningTypes = [
  {
    label: 'Tất cả loại cảnh báo',
    value: 'ALL'
  },
  {
    label: 'Cảnh báo mất kết nối',
    value: 'DEVICE_OFFLINE'
  },
  {
    label: 'Cảnh báo cần đi đọc chỉ số thủ công',
    value: 'MANUAL_METER_READING'
  },
  {
    label: 'Cảnh báo bị tấn công tháo rời',
    value: 'DEMOLITION'
  },
  {
    label: 'Cảnh báo tấn công từ tính',
    value: 'MAGNETIC'
  },
  {
    label: 'Cảnh báo rò rỉ nước',
    value: 'LEAKAGE'
  },

  {
    label: 'Cảnh báo tiêu thụ bất thường',
    value: 'ABNORMAL_CONSUMPTION'
  },

  {
    label: 'Cảnh báo bị kẹt công tơ',
    value: 'STOP_STATUS'
  },
  {
    label: 'Cảnh báo dòng chảy ngược',
    value: 'REVERSE_FLOW'
  },
  {
    label: 'Cảnh báo dòng chảy vượt ngưỡng',
    value: 'OVER_FLOW'
  }
];

export const downloadBlobFile = async (url, fileName, data, typeReq = 'GET') => {
  let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
  if (!isEmpty(user)) {
    user = JSON.parse(user);
  } else {
    return;
  }
  const response =
    typeReq === 'GET'
      ? await axios.get(url, {
          params: data,
          headers: { Authorization: `Bearer ${user?.accessToken}` },
          responseType: 'blob'
        })
      : await axios.post(url, null, {
          params: data,
          headers: { Authorization: `Bearer ${user?.accessToken}` },
          responseType: 'blob'
        });
  const type = response.headers['content-type'];
  const blob = new Blob([response.data], { type: type });
  const link1 = document.createElement('a');
  link1.href = window.URL.createObjectURL(blob);
  link1.setAttribute('download', fileName);
  document.body.appendChild(link1);
  link1.click();
};

export const uploadBlobFile = async (url, fileName, formData) => {
  let user = loadFromLocalStorageObjectFromBase64(contantAuthentication.DATA_AUTH);
  if (!isEmpty(user)) {
    user = JSON.parse(user);
  } else {
    return;
  }
  const response = await axios.post(url, formData, {
    headers: {
      Authorization: `Bearer ${user?.accessToken}`,
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob'
  });
  const type = response.headers['content-type'];
  const blob = new Blob([response.data], { type: type });
  const link1 = document.createElement('a');
  link1.href = window.URL.createObjectURL(blob);
  link1.setAttribute('download', fileName);
  document.body.appendChild(link1);
  link1.click();
};

export const convertPN = [
  {
    value: 1,
    label: 1
  },
  {
    value: 2,
    label: 10
  },
  {
    value: 3,
    label: 100
  },
  {
    value: 4,
    label: 1000
  },
  {
    value: 9,
    label: 3
  },
  {
    value: 10,
    label: 30
  }
];

export const extractQRCode = (input) => {
  if (!input) return { imei: null, serialNumber: null };
  const imeiMatch = input?.match(/IMEI:(\d+)/);
  const snMatch = input?.match(/S\/N:(\d+)|Serial:(\d+)/);
  const imeiMatchAlt = input?.match(/IMEI:(\d+)\sS\/N:(\d+)/);

  return {
    imei: imeiMatchAlt ? imeiMatchAlt[1] : imeiMatch ? imeiMatch[1] : null,
    serialNumber: imeiMatchAlt ? imeiMatchAlt[2] : snMatch ? snMatch[1] || snMatch[2] : null
  };
};
